<template>
      
 <div id="new-paint" v-show="is_open">
      <loading
        :active="false"
        :can-cancel="false"
        :is-full-page="false"
      />
      <div
        style="text-align:left; margin-top: 15px;"
      >
      <b-form-group>
    
        Child name: 
        <div style="display:flex; margin-top:16px" class="mb-10">
            <div style="width:70%">
            <b-form-input
            id=""
            ref=""
            v-model="new_node.node_name"
            placeholder="Node name"
            />
            </div>
        </div>
        <div style="margin-top:15px">
          <b-form-checkbox
                v-model="new_node.perform_normalization"
                class="custom-control-secondary"
        > 
            Perform Normalization 
        </b-form-checkbox>
        <b-form-checkbox
                v-model="new_node.perform_sampling"
                class="custom-control-secondary"
            
        > 
            Perform Data Sampling 
        </b-form-checkbox>
        </div>      
        <div style="margin-top:10px">
          Cells:
          <b-form-spinbutton-input
            :state="false"
            style="margin-top:5px"
            id="80"
            v-model="totalCells"
            :disabled="false"
            :readonly="false"
            :min="1"
            :max="1000000"
            :width="140"
   
          />

       

   
  
         

          <div class="markerList" style="margin-top:24px">
            <div>
     
              <h6>Non included clusters</h6>

              <div
                :list="nonIncluded"
                :group="{name:'tags'}"
                class="mb-1 marker-selectable"
              >
                <b-badge
                  v-for="(marker, index) in nonIncluded"
                  :key="index"
                  class="m-50"
                  style="cursor:pointer"
                  :variant="'light-warning'"
                  @click="include(marker, index)"
                >
                  {{ marker }}
                </b-badge>
              </div>
            </div>

            <!-- add tag -->
            <div>
              <h6>Included clusters</h6>

              <div
                :list="included"
                :group="{name: 'tags'}"
                class="mb-1 marker-selectable"
              >
                <b-badge
                  v-for="(marker, index) in included"
                  :key="index"
                  class="m-50"
                  style="cursor:pointer"
                  :variant="'light-success'"
                  @click="noinclude(marker, index)"
                >
                  {{ marker }}
                </b-badge>
              </div>
            </div></div>
          

        <b-col>
          <b-button
       
       variant="primary"
       size="sm"
       class="mt-1"
      
       @click="splitNode"
     
     >
       Split node
     </b-button>
        </b-col>
        
      </div>
      </b-form-group>
      </div>
      </div>
      
      

     
        
  
    
     
  
    
       
        
    
  </template>
  <script>
  import Vue from 'vue'
  import { BButton,  BFormInput, BFormGroup, BRow, BCol, BFormCheckbox, BFormSpinbutton, BBadge } from 'bootstrap-vue'
  import InputColorPicker from 'vue-native-color-picker'
  import 'vue-range-component/dist/vue-range-slider.css'
  import VueRangeSlider from 'vue-range-component'
  import store from '@/store/index'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import BlockInput from '../components/blockInputs.vue'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { ToggleButton } from 'vue-js-toggle-button'
  import BFormSpinbuttonInput from '@core/components/b-form-spinbutton-input/BFormSpinbuttonInput.vue'
  import Swal from 'sweetalert2'
  import vueMultiSelect from 'vue-multi-select';
  import 'vue-multi-select/dist/lib/vue-multi-select.css';
  
  const { url, port, auth } = store.state.appConfig.api
  const headers = {
    authentication: auth,
    'Content-Type': 'application/json',
  }
  
  export default {
    components: {
      BFormInput,
      BFormGroup,
      BRow,
      BFormSpinbuttonInput,
      BCol,
      InputColorPicker,
      VueRangeSlider,
      BButton,
      Loading,
      ToggleButton,
      BFormCheckbox,
      BlockInput,
      BFormSpinbutton,
      vueMultiSelect,
      BBadge
    },
    props: {
     
      data:  {
        required: true,
        type: [Object, String],
        default: null,
      },
      
   
      
     
    },
    data() {
      return {
        new_node: {
            hierarchy_name: '',
            node_name: '',
            perform_normalization: true,
            perform_sampling: true,
            cell_number: 25000,

        },
        totalCells:25000,
        modelOptions: [],
        included: [],
        nonIncluded: [],
        test: 25000,
        isLoadingInfo: true,
        is_open: true,
        change_percent: false,
        newcolor: this.color,
        histogram_x: [],
        histogram_y: [],
        histogram: {},
        update: 0,
        cluster_selected:'',
        img: '',
        isLoading: false,
        newbrightness: this.brightness,
        newcontrast: this.contrast,
        newsaturation: this.saturation,
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
        },
        tooltipStyle: {
          backgroundColor: '#666',
          borderColor: '#666',
        },
        processStyle: {
          backgroundColor: '#999',
        },
        objectNameEdit:'',
        colorPickerEdit:'',
      
      }
    },
    created() {
      try{
      
      this.nonIncluded = Object.keys(JSON.parse(this.data.clusters[0].final_clusters))
      }catch(e)
      {this.nonIncluded = []}
     /* this.nonIncluded = this.data.clusters.filter(function (x, i, a) { 
    return a.indexOf(x) == i; 
});*/

      
  
    },
  
  
    
    methods: {
      preprocess(node_id, force = false) {

this.version = null


axios.post(`${url}:${port}/downstream-preprocess/${this.data.project_id}/${node_id}`, { user: 1, force }, { headers }).then(result => {

})

},
    
      splitNode(){

            Swal.fire({
              title: 'Run all steps',
              text: "Do you want to compute all the steps directly up to digital reconstruction?",
              showCancelButton: true,
              confirmButtonText: 'Run all steps',
              cancelButtonText: 'Go step by step',
              customClass: {
                confirmButton: 'btn btn-primary mt-4',
                cancelButton: 'btn btn-primary ml-1 mt-4',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.createChildNode( 1)
              }
              else{
                this.createChildNode( 0)
              }
            })
          
      },
      calculate_cells(node_id){
          console.log("Calculate cells")
          const { data, new_node, included} = this
          
   
          axios.post(`${url}:${port}/downstream-cells/${data.project_id}/${node_id}`, { }, { headers }).then(result => {
          
            console.log(result)
          })
        },
      createChildNode( compute = 0){
        var finalClustersSum = 0
        try{
        const parentClusters= JSON.parse(this.data.clusters[0].final_clusters)
        const finalClusters = Object.keys(parentClusters)
        for(var i=0;i<finalClusters.length; i++){
          if(this.included.includes(finalClusters[i])){
            finalClustersSum += Number(parentClusters[finalClusters[i]])
          }
        }
      }catch(e){}
        const { data, new_node, included, totalCells} = this
        var data2send = {
          project_id: data.project_id,
          parent_id: data.parent_node_id,
          description: 'descp',
          parent_version_id: data.parent_version_id,
          name: new_node.node_name,
          clusters:  included, 
          do_all_steps: compute,
          totalCells: totalCells, 
          finalSum: finalClustersSum
        }
        
        axios.put(`${url}:${port}/downstream-newchildnode`, data2send, { headers }).then(async result => {
          console.log("result,", result, result.data, result.data.id)
            this.calculate_cells(result.data.id)
           if(compute != 0){
           // this.preprocess(result.data.id)
           }
        
          
         location.reload()
        })

        
        
      },
      include(marker, index) {
      this.included.push(marker)
      this.nonIncluded.splice(index, 1)
    },
    noinclude(marker, index) {
      this.nonIncluded.push(marker)
      this.included.splice(index, 1)
    },
      addNewNode(){
        const { new_node, test, parent_id, project_id } = this
        var descp = 'node'
        if(parent_id == 0){
          descp = new_node.hierarchy_name ?? ''
        }
        var data2send = {
          project_id: project_id.id,
          name: new_node.node_name,
          description: descp,
          parent_id: parent_id,
          do_all_steps:0
        }
        axios.put(`${url}:${port}/downstream-newnode`, data2send, { headers }).then(async result => {
          console.log("result")
        })

        this.new_node = new_node
      }
    
      
     
      
    
    },
  }
  </script>
  <style>
  .markerList{
  display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: stretch;
    align-content: center;
}
.cluster-cellss{
  background-color: yellow;
}
.markerList div{
  flex: 0 0 50%;
}
.markerList h6{
  margin-left: 10px;
}
  .icp__input {
      height: 20px!important;
      width: 20px!important;
      margin-right:10px;
  }
  .swal2-actions{
   margin: 0 10px;
    /* display: none !important;  */
  }
  .vue-range-slider.slider-component {
    margin-left:0px!important;
  }
  .sat_slider{
      margin-top: -30px!important;
      margin-bottom: 20px!important;
  }
  #new-paint .swal2-confirm swal2-styled{
    /* display: none; */
    
  }
  /* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
      background-color: dodgerblue !important;
  } */
  
  </style>
  <style scoped>
  
  h4{
      display: flex;
      align-items: flex-start;
  }
  #content{
      display: flex;
      width: 100%;
      height: 400px;
      justify-content: space-between;
  }
  #picture{
      width: 55%;
      display: flex;
      align-items: center;
  }
  #picture img{
      max-width: 90%;
      max-height: 365px
  }
  #histograms{
      width: 40%;
  }
  .mb-10{
    margin-bottom: 10px;
  }

.validInput .input-group-text{
    background-color: #29c770;
    color: #fff;
}
.b-form-spinbutton{
  max-width: 100px;
}
.is-valid.b-form-spinbutton{
      max-width: 135px!important;
}
.spinBtRow{
  flex-direction: column;
}
.spinBtRow div{
    max-width: 100%!important;
}
.spinBtRow div.input-group{
  max-width: 110px!important;
}

.marker-selectable{
  background: whitesmoke;
  padding: 10px;
  margin: 10px;
  height: calc(100% - 30px)

 
}

</style>
    